@if (isLoading) {
  <mat-spinner></mat-spinner>
}

<app-generic-filter-selector
  [availableFilters]="availableConceptsToFilters$ | async"
  (filterClick)="onConceptFilterSelected($event)"
  [extraContextInfoForAccessibility]="'accessibility.concept_filter' | translate"
></app-generic-filter-selector>